export class Routes {
    public static HOME = "/";
    public static LOGIN = "/login";
    public static NOT_FOUND = "/not-found";
    public static RESET_PASSWORD = "/reset-password";
    public static SUMMARY_REPORT = "/summary-report";
    public static IMPORTED_SONGS = "/imported-songs";
    public static SCRAPED_DATA = "/scraped-data";
}
